<template>

    <div v-if="entry" class="audition-detail-panel">

        <div class="panel-title">{{ entry.title }}</div>

        <div class="info-row"><span class="label">创作者</span><span>{{ entry.userName || '-' }}</span></div>

        <div class="info-row"><span class="label">彩种</span><span>{{ preTypeLabel }}</span></div>

        <div class="info-row"><span class="label">彩票期号</span><span>{{ entry.issueNumber || '-' }}</span></div>

        <div class="info-row"><span class="label">注数</span><span>{{ entry.betCount != null ? entry.betCount : '-' }}</span></div>

        <div class="info-row"><span class="label">投注金额</span><span>{{ entry.betAmount != null ? entry.betAmount + ' 元' : '-' }}</span></div>

        <div class="info-row"><span class="label">预期奖金</span><span>{{ entry.expectedPrize != null ? entry.expectedPrize + ' 元' : '-' }}</span></div>

        <div class="info-row"><span class="label">累计积分</span><span>{{ formatScore(entry.totalScore) }}</span></div>

        <div class="info-row"><span class="label">本期命中</span><span>{{ entry.redHitCount != null ? entry.redHitCount + ' 个' : '-' }}</span></div>

        <div class="info-row"><span class="label">本期积分</span><span>{{ formatScore(entry.periodScore) }}</span></div>

        <div class="info-row"><span class="label">提交时间</span><span>{{ entry.createTime || '-' }}</span></div>

        <div class="info-row" v-if="entry.badge"><span class="label">荣誉标识</span><span>{{ entry.badge }}</span></div>

        <div class="info-row">

            <span class="label">预期收益分析</span>

            <span class="text-block">{{ entry.profitAnalysis || '-' }}</span>

        </div>

        <div class="info-row">

            <span class="label">投注内容</span>

            <div class="bet-content-wrap">

                <audition-bet-content

                    :bet-conditions="entry.betConditions"

                    :bet-content="entry.betContent"

                    :attachment-file-name="entry.attachmentFileName"

                    :has-attachment="!!entry.hasAttachment"

                    :pre-type="entry.preType" />

                <el-button

                    v-if="canDownload"

                    type="primary"

                    size="small"

                    plain

                    class="download-btn"

                    :loading="downloading"

                    @click="$emit('download')">

                    下载投注文件

                </el-button>

            </div>

        </div>

        <div class="risk-tip">

            风险提示：彩票投注存在风险，本方案仅供参考，请理性投注，量力而行。

        </div>

    </div>

</template>



<script>

import AuditionBetContent from './AuditionBetContent.vue'



export default {

    name: 'EntryDetailPanel',

    components: { AuditionBetContent },

    props: {

        entry: { type: Object, default: null },

        lotteryOptions: { type: Array, default: () => [] },

        downloading: { type: Boolean, default: false }

    },

    computed: {

        preTypeLabel () {

            if (!this.entry || !this.entry.preType) return '-'

            const item = this.lotteryOptions.find(o => o.dictValue === this.entry.preType)

            return item ? item.dictLabel : this.entry.preType

        },

        canDownload () {

            if (!this.entry) return false

            return !!(this.entry.hasAttachment

                || (this.entry.betConditions && this.entry.betConditions.length)

                || (this.entry.betContent && this.entry.betContent.trim()))

        }

    },

    methods: {

        formatScore (val) {

            if (val == null || val === '') return '-'

            return Number(val).toLocaleString()

        }

    }

}

</script>



<style lang="scss" scoped>

.bet-content-wrap {

    flex: 1;

    min-width: 0;

}

.download-btn {

    margin-top: 10px;

}

</style>

